import { IncomingTopicsEffects } from './effects';
export * as IncomingTopicsActions from './actions';
export * as IncomingTopicsReducer from './reducer';
export * as IncomingTopicsSelectors from './selectors';
export const INCOMING_TOPICS_EFFECTS: any[] = [IncomingTopicsEffects];
